/* eslint-disable import/no-internal-modules */
import PaginationComponent, { PaginationProps } from '@insided/deprecated-control/ui-components/PaginationComponent'
import DropdownControl from '@insided/deprecated-preact-components/dropdown/DropdownControl'
import Button from '@insided/control/uikit/Button'
import { REPLY_SORTING_OPTIONS, setRepliesPaginationParams } from './utils'
import { Reply } from '../../interfaces'

interface Props {
  replies: Reply[]
  repliesPagination: PaginationProps
  getReplies: (page?: number, pageSize?: number, sort?: string) => Promise<any>
  repliesSorting: string
  setRepliesSorting: (repliesSorting: string) => void
}

const RepliesFooter = ({ replies, repliesPagination, getReplies, repliesSorting, setRepliesSorting }: Props) => {
  return (
    <div className='topic-moderation--replies-footer'>
      {replies.length > 0 &&
        <PaginationComponent
          displayListUpwards
          pagination={repliesPagination}
          onPageChange={(async page => {
            setRepliesPaginationParams({ page, pageSize: repliesPagination.pageSize })
            await getReplies(page, repliesPagination.pageSize)
          })}
          onPageSizeChange={async pageSize => {
            setRepliesPaginationParams({ page: 1, pageSize })
            await getReplies(1, pageSize)
          }}
        />}
      {replies.length > 0 &&
        <DropdownControl
          displayListUpwards
          align='adjust'
          triggerClass='dropdown-wrapper'
          trigger={
            <Button
              icon='arrowDropdown'
              title={REPLY_SORTING_OPTIONS[repliesSorting]}
              // eslint-disable-next-line @gorazdo/preact/prefer-classname
              className='qa-topic-moderation-reply-sort'
            />
          }
          items={Object.keys(REPLY_SORTING_OPTIONS).map((value: string) => ({
            title: REPLY_SORTING_OPTIONS[value],
            value,
            onClick: async () => await getReplies(1, repliesPagination.pageSize, value)
              .then(() => setRepliesSorting(value))
          }))}
        />}
    </div>
  )
}

export default RepliesFooter
